import { Platform } from "./platform";
import { ResponsiveLayout } from "./responsiveLayout";
import {
  getClickThroughSource,
  ClickThroughSourceMediaType,
} from "./clickThroughSource";

const getPageName = (
  pageType: string,
  site?: string,
  siteSection?: string,
  siteSubSection?: string,
): string =>
  [site, siteSection, siteSubSection, pageType].filter(Boolean).join(":");

export type GetPageDataArgs = {
  pageType: string;
  site?: string;
  siteSection?: string;
  siteSubSection?: string;
  siteSubSubSection?: string;
  siteSubSubSubSection?: string;
  articleName?: string;
  variantName?: string;
  breadcrumbs?: string;
  clickThroughSourcePage?: string;
  clickThroughSourceElement?: string;
  clickThroughSourceType?: string;
  clickThroughSourceMedia?: ClickThroughSourceMediaType;
  clickThroughSourceAdditionalFieldKey?: string;
  clickThroughSourceAdditionalFieldValue?: string;
  platform: Platform;
  responsiveLayout: ResponsiveLayout;
  pageNameOverride?: string;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const getPageData = (data: GetPageDataArgs): (() => {}) => {
  const {
    pageType,
    site = "rea",
    siteSection,
    siteSubSection,
    siteSubSubSection,
    siteSubSubSubSection,
    articleName,
    variantName,
    breadcrumbs,
    clickThroughSourcePage,
    clickThroughSourceElement,
    clickThroughSourceType,
    clickThroughSourceMedia,
    clickThroughSourceAdditionalFieldKey,
    clickThroughSourceAdditionalFieldValue,
    platform,
    responsiveLayout,
    pageNameOverride,
  } = data;

  // eslint-disable-next-line @typescript-eslint/ban-types
  return (): {} => ({
    page: {
      schema: "iglu:au.com.realestate/page/jsonschema/2-0-17",
      data: {
        page_name:
          pageNameOverride ||
          getPageName(pageType, site, siteSection, siteSubSection),
        page_type: pageType,
        site: site,
        site_section: siteSection,
        site_sub_section: siteSubSection,
        site_sub_sub_section: siteSubSubSection,
        site_sub_sub_sub_section: siteSubSubSubSection,
        article_name: articleName,
        variant_name: variantName,
        breadcrumbs: breadcrumbs,
        click_through_source: getClickThroughSource({
          page: clickThroughSourcePage,
          element: clickThroughSourceElement,
          sourceType: clickThroughSourceType,
          media: clickThroughSourceMedia,
          additionalFieldKey: clickThroughSourceAdditionalFieldKey,
          additionalFieldValue: clickThroughSourceAdditionalFieldValue,
        }),
        language: "english",
        platform: platform.getName(),
        responsive_layout: responsiveLayout,
        rendered_on: platform.getRenderedOn(),
      },
    },
  });
};
